import {
  IViewLocationGroupList,
  IViewLocationList,
  IViewLocations,
} from 'src/interfaces';

export const formatFormValues = (
  selectedLocation: IViewLocationList,
  locationGroups: IViewLocationGroupList[],
) => {
  if (!selectedLocation?.channels) return [];

  return selectedLocation.channels.map((channel) => {
    const filteredLocationGroups = locationGroups.filter(
      (locationGroup) => locationGroup.channel_name === channel,
    );

    const assignedLocationGroup = filteredLocationGroups.find((locationGroup) =>
      locationGroup.locations.some(
        (location) => location.location_code === selectedLocation.location_code,
      ),
    );

    return {
      name: channel,
      locationGroups: filteredLocationGroups,
      selectedLocationGroupId: assignedLocationGroup?.id || undefined,
    };
  });
};

export const getSelectedLocationWithViewLocationType = (
  viewLocationGroupData: IViewLocations,
  locationCode: string,
) =>
  viewLocationGroupData?.locationGroups
    ?.flatMap((locationGroup) => locationGroup.locations)
    ?.find((location) => location.location_code === locationCode) ??
  viewLocationGroupData?.unassignedLocations?.find(
    (loc) => loc.location_code === locationCode,
  );
